import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {Text, TextButton} from 'wix-ui-tpa/cssVars'
import {useCurrencyFormatter} from '../../../../../../../commons/hooks/currency'
import {getLocale} from '../../../../../../../commons/selectors/environment'
import {usePageStateSelector} from '../../../../hooks/state'
import {isCouponInputVisible, isGiftCardInputVisible} from '../../../../selectors/checkout-options'
import {isMembershipSelectorVisible} from '../../../../selectors/paid-plans'
import {GiftCardInput} from '../../../gift-card-input'
import {CouponInput} from '../../../summary/coupon-input'
import {MembershipDropdown} from '../../../summary/membership-dropdown'
import s from './checkout-summary.scss'
import {classes} from './checkout-summary.st.css'
import {CheckoutSummaryProps} from './interfaces'

export const CheckoutSummary = ({onViewAllItems, currentStep, buyerTotal}: CheckoutSummaryProps) => {
  const {t} = useTranslation()
  const locale = usePageStateSelector(getLocale)
  const {getFormattedMoney} = useCurrencyFormatter(locale)
  const {experiments} = useExperiments()

  const couponInputVisible = usePageStateSelector(isCouponInputVisible)
  const membershipSelectorVisible = usePageStateSelector(isMembershipSelectorVisible)
  const giftCardInputVisible = usePageStateSelector(isGiftCardInputVisible)

  return (
    <div className={s.container}>
      {couponInputVisible && <CouponInput currentStep={currentStep} mobile />}
      {experiments.enabled(ExperimentNames.GiftCardsViewer) && giftCardInputVisible && (
        <GiftCardInput mobile currentStep={currentStep} />
      )}
      {membershipSelectorVisible && <MembershipDropdown currentStep={currentStep} mobile />}
      <div className={s.summary}>
        <div className={classNames(s.row, classes.details)}>
          <Text>{t('mobile.couponForm.title')}</Text>
          <TextButton onClick={onViewAllItems} data-hook={DH.SHOW_SUMMARY_BUTTON}>
            {t('mobile.summary.showTickets')}
          </TextButton>
        </div>
        <div className={classNames(s.row, classes.total)} data-hook={DH.CHECKOUT_SUMMARY_TOTAL}>
          <Text>{t('mobile.ticketsPicker.total')}</Text>
          <Text>{getFormattedMoney(buyerTotal)}</Text>
        </div>
      </div>
    </div>
  )
}
